import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a1029266&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.less?vue&type=style&index=0&id=a1029266&prod&scoped=true&lang=less&external"
import style1 from "./index.vue?vue&type=style&index=1&id=a1029266&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1029266",
  null
  
)

export default component.exports